import { isNative, isAndroid } from './platform';

/**
 * Barre d'état système (heure, réseau, batterie).
 *
 * Le projet cible `targetSdk 36` : à partir d'Android 15, le système impose le
 * mode bord-à-bord, la barre d'état se superpose donc à la webview. Sans
 * réglage, Android conserve le texte clair hérité du thème, illisible sur
 * l'en-tête blanc de l'application — l'heure et la batterie disparaissent.
 *
 * On demande donc explicitement des icônes sombres sur fond clair. La hauteur
 * de la barre est récupérée côté CSS par `env(safe-area-inset-top)`, dont la
 * barre d'application (.oc-appbar) se sert comme marge haute.
 */
export async function initStatusBar() {
  if (!isNative()) return;

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');

    // Style.Light = fond clair, donc contenu (heure, icônes) en sombre.
    await StatusBar.setStyle({ style: Style.Light });

    if (isAndroid()) {
      // La superposition est le comportement imposé par Android 15+ ; on
      // l'active aussi sur les versions antérieures pour un rendu identique.
      await StatusBar.setOverlaysWebView({ overlay: true });

      // Sans effet sur Android 15+, où la couleur de fond n'est plus
      // paramétrable : l'appel est enveloppé pour ne pas remonter d'erreur.
      try {
        await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
      } catch {
        /* Android 15+ : réglage retiré de la plateforme. */
      }
    }
  } catch (e) {
    console.warn('Configuration de la barre d\'état impossible', e);
  }
}
